export default __webpack_public_path__ + "locales/it/JavascriptSdk.json?hash=b6be2d2cfe7ccae37d1c1b297e1fadf8";